import { util } from 'echarts';
import type { PresetMode } from '../..';
import { type ThemeParser } from '../../../core/theme';
import { preprocessXAxis, defaultXAxisOpt, parseXAxis } from '../../ainvest/component/xAxis';
import { FONT_LEVEL_LIST, fontColor } from '../../mobile/static/font';

const mergeXAxis = (mode: PresetMode) => {
  // 基于移动端ainvest规范修改
  return {
    axisLine: {
      dvZ: 3,
      lineStyle: {
        width: 1
      }
    },
    axisLabel: {
      color: fontColor(FONT_LEVEL_LIST.LEVEL1, mode),
      fontSize: 11,
      lineHeight: 16,
      margin: 12
    },
    axisPointer: {
      z: 5,
      label: {
        fontSize: 11,
        margin: 12,
        lineHeight: 16,
        // 根据设计师调整padding值
        // eslint-disable-next-line no-magic-numbers
        padding: [0, 3, 0, 3]
      }
    }
  };
};

const defaultXAxis = (mode: PresetMode) => {
  return util.merge(defaultXAxisOpt(mode), mergeXAxis(mode), true);
};

export function xAxisThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  preprocessXAxis(option);
  parseXAxis(option, defaultXAxis(themeMode));
}
